<template>
  <div class="pedal-selection">
    <div class="pedal-selection__filters">
      <PedalFilters />
    </div>
    <div class="pedal-selection__content">
      <h1>{{ t('setup.pedal.selection') }}</h1>

      <PedalSelection @select="select" />

      <div class="pedal-selection__buttons">
        <BfButton
          :type="ButtonType.Outlined"
          @click="cancel"
        >
          {{ t('common.cancel') }}
        </BfButton>
        <BfButton
          :state="selected ? ButtonState.Enabled : ButtonState.Disabled"
          @click="install"
        >
          {{ t('common.install') }}
        </BfButton>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { usePedalStore } from '@/store/pedalStore'
import { useMeasurementStore } from '@/store/measurementStore'
import { useRouter } from 'vue-router'
import PedalFilters from '@/components/setup/pedal/PedalFilters.vue'
import PedalSelection from '@/components/setup/pedal/PedalSelection.vue'
import { ButtonState, ButtonType, BfButton } from '@finetic/bikefitting-ui'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const router = useRouter()
const pedalStore = usePedalStore()
const measurementStore = useMeasurementStore()
const selected = ref()

pedalStore.reset()

const select = (pedal: any) => {
  selected.value = pedal
}

const cancel = () => {
  router.push({
    name: router.currentRoute.value.meta.update ? 'analysis' : 'setup',
  })
}

const install = () => {
  if (measurementStore.selectedMeasurement) {
    measurementStore.selectedMeasurement.pedal.active = selected.value
  }

  router.push({
    name: router.currentRoute.value.meta.update ? 'analysis' : 'setup',
  })
}
</script>

<style lang="scss">
.pedal-selection {
  display: grid;
  grid-template-columns: 40% 60%;
  height: 100%;

  &__filters {
    background-color: #f5f5f5;
  }

  &__content {
    background-color: #fbfbfb;
    padding: 2.4rem;
  }

  &__buttons {
    margin-top: 3.2rem;
    display: flex;
    justify-content: flex-end;
    gap: 0.8rem;
  }
}
</style>
